import Layout from "@/components/feature/Layout";
import Seo from "@/components/feature/Seo";
import JsonLd from "@/components/feature/JsonLd";
import CtaBanner from "@/components/feature/CtaBanner";
import SectionHeading from "@/components/base/SectionHeading";
import useScrollReveal from "@/hooks/useScrollReveal";
import { serviceAreas } from "@/data/serviceAreas";
import { services } from "@/data/services";
import ServicesHero from "./sections/ServicesHero";
import MajorServiceSection from "./sections/MajorServiceSection";
import RelatedServices from "./sections/RelatedServices";
import ServicesContactCta from "./sections/ServicesContactCta";

const listItems = [
  ...serviceAreas.map((area) => ({ name: area.eyebrow, url: `https://orthospine.care${area.href}` })),
  ...services.map((service) => ({ name: service.title, url: `https://orthospine.care/services/${service.slug}` })),
];

const structuredData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "CollectionPage",
      "@id": "https://orthospine.care/services#page",
      name: "Our Services",
      url: "https://orthospine.care/services",
      description:
        "Orthopaedic and spine services in Trichy, including the two primary specialist care areas: Spine Care and Orthopaedic Care.",
    },
    {
      "@type": "ItemList",
      itemListElement: listItems.map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: item.name,
        url: item.url,
      })),
    },
    {
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: "https://orthospine.care/" },
        { "@type": "ListItem", position: 2, name: "Services", item: "https://orthospine.care/services" },
      ],
    },
  ],
};

export default function Services() {
  useScrollReveal();

  return (
    <Layout>
      <Seo
        title="Our Services | Orthopaedic & Spine Care in Trichy"
        description="Explore the orthopaedic and spine services at Ortho Spine Care in Trichy — Spine Care and Orthopaedic Care, plus joint replacement, arthroscopy, fracture and tendon care."
        path="/services"
      />
      <JsonLd id="ld-services" data={structuredData} />

      <ServicesHero />

      <section className="bg-background-50 pt-16 md:pt-24">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <SectionHeading
            eyebrow="Two specialist care areas"
            title="The primary specialist services of Orthospine"
            description="Spine Care and Orthopaedic Care are the two areas where specialist experience matters most. Explore each to understand the conditions treated and the care available."
          />
        </div>
      </section>

      {serviceAreas.map((area, index) => (
        <MajorServiceSection key={area.slug} area={area} index={index} />
      ))}

      <RelatedServices />

      <CtaBanner
        title="Ready to take the next step?"
        text="Request an appointment with our orthopaedic and spine specialist, or call the clinic directly to speak with our team about the right service for you."
      />

      <ServicesContactCta />
    </Layout>
  );
}